import styled from 'styled-components';

export const Container = styled.div`
    grid-area: content;
    background-color: #efefef;
    padding: 2rem;
`;
